import useGetRejectReasonsData from './useGetRejectReasonsData'
export default useGetRejectReasonsData
